import { CSSResultGroup, html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'

import { style } from './card.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'

export const cardVariants = ['default', 'wide', 'inline'] as const
export type cardVariantsType = typeof cardVariants[number]

@customElement('cse-card')
export class CSECard extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  @property({ type: String })
  variant: cardVariantsType = 'default'

  override firstUpdated() {
    this.shadowRoot?.querySelectorAll<HTMLSlotElement>('slot[name]').forEach(slot => {
      const wrapper = slot.parentElement
      if (wrapper) wrapper.hidden = slot.assignedNodes({ flatten: true }).length === 0
    })
  }

  private _onSlotChange(e: Event) {
    const slot = e.target as HTMLSlotElement
    const wrapper = slot.parentElement
    if (wrapper) wrapper.hidden = slot.assignedNodes({ flatten: true }).length === 0
  }

  private renderDefault() {
    return html`
      <div class="cse-card variant-${this.variant}">
        <div class="header"><slot name="header" @slotchange="${this._onSlotChange}"></slot></div>
        <div class="body"><slot name="body" @slotchange="${this._onSlotChange}"></slot></div>
        <div class="footer"><slot name="footer" @slotchange="${this._onSlotChange}"></slot></div>
      </div>
    `
  }

  private renderInline() {
    return html`
      <div class="cse-card variant-${this.variant}">
        <div class="header"><slot name="header" @slotchange="${this._onSlotChange}"></slot></div>
        <div class="content-wrapper">
          <div class="body"><slot name="body" @slotchange="${this._onSlotChange}"></slot></div>
          <div class="footer"><slot name="footer" @slotchange="${this._onSlotChange}"></slot></div>
        </div>
      </div>
    `
  }

  override render() {
    return this.variant === 'inline' ? this.renderInline() : this.renderDefault()
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cse-card': CSECard
  }
}
